import GameAnimations from "./animations/GameAnimations";
import ResourcesDispatcher from "./config/ResourcesDispatcher";
import Cell from "./gameUtil/Base/Cell";
import FreeSpinCell from "./gameUtil/Free/FreeSpinCell";
import FreeSpinReel from "./gameUtil/Free/FreeSpinReel";
import Pick from "./gameUtil/Pick/Pick";
import CreationManager from "./managers/CreationManager"

declare global {
    interface Window {
        animationLib: any
    }
}

const api = {
    CreationManager,
    FreeSpinCell,
    FreeSpinReel,
    ResourcesDispatcher,
    Pick,
    GameAnimations,
    Cell
};

(window as any).animationLib = api;